const formatHistoryDate = (timestamp) => {
  if (!timestamp) return "—";
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const mapStatus = (status) => {
  switch (status) {
    case "completed":
      return "Concluída";
    case "pending":
      return "Em processamento";
    case "failed":
      return "Falhou";
    default:
      return status;
  }
};

const normalizeAsset = (asset) => {
  const value = String(asset || "").trim().toLowerCase();
  return value || "";
};

const roundRate = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n * 10000) / 10000;
};

const resolveRate = (operation, amountBrl, amountStable) => {
  const explicit = roundRate(operation?.rate);
  if (explicit != null) return explicit;

  const brl = Number(amountBrl);
  const stable = Number(amountStable);
  if (!Number.isFinite(brl) || !Number.isFinite(stable) || brl <= 0 || stable <= 0) {
    return null;
  }
  // Avoid inventing rate=1 when legs were wrongly persisted as the same qty.
  if (Math.abs(brl - stable) <= 0.01) return null;
  return roundRate(brl / stable);
};

const resolveAmountBrl = (operation, amount) => {
  const explicit = Number(operation?.amountBrl ?? operation?.amount_brl);
  if (Number.isFinite(explicit) && explicit > 0) return explicit;
  const rate = roundRate(operation?.rate);
  return rate != null ? amount * rate : 0;
};

export const mapBaasOperationToStablesHistoryItem = (operation) => {
  const base = {
    id: operation.id,
    date: formatHistoryDate(operation.timestamp ?? operation.createdAt),
    status: mapStatus(operation.status),
    reference: operation.reference,
  };
  const asset = normalizeAsset(operation.asset);
  const amount = Number(operation.amountStable ?? operation.amount) || 0;
  const amountBrl = resolveAmountBrl(operation, amount);
  const rate = resolveRate(operation, amountBrl, amount);

  switch (operation.type) {
    case "buy":
      return {
        ...base,
        historyKind: "purchases",
        asset,
        amountStable: amount,
        amountBrl,
        rate: rate ?? undefined,
      };
    case "sell": {
      const amountTo =
        amountBrl ||
        Number(operation.amountTo ?? operation.toAmount) ||
        0;
      const sellRate = resolveRate(operation, amountTo, amount);
      return {
        ...base,
        historyKind: "sales",
        from: normalizeAsset(operation.from) || asset,
        amountFrom: amount,
        amountTo,
        rate: sellRate ?? undefined,
      };
    }
    case "transfer":
      return {
        ...base,
        historyKind: "transfers",
        asset,
        amount,
        destination: operation.reference,
      };
    case "swap": {
      const from =
        normalizeAsset(operation.from) ||
        normalizeAsset(operation.fromAsset) ||
        asset;
      // Never default destination to USDT — empty means unknown pair, not USDT→USDT.
      const to =
        normalizeAsset(operation.to) ||
        normalizeAsset(operation.toAsset) ||
        "";
      const amountFrom =
        Number(operation.amountFrom ?? operation.fromAmount) || amount;
      const amountTo =
        Number(operation.amountTo ?? operation.toAmount) || 0;
      return {
        ...base,
        historyKind: "swaps",
        from,
        to,
        amountFrom,
        amountTo: amountTo > 0 ? amountTo : amountFrom,
        rate: rate ?? undefined,
      };
    }
    case "deposit":
      return {
        ...base,
        historyKind: "deposits",
        asset,
        amount,
      };
    default:
      return {
        ...base,
        historyKind: "purchases",
        asset,
        amountStable: amount,
        amountBrl,
        rate: rate ?? undefined,
      };
  }
};

export const mapBaasOperationsToStablesHistory = (operations = []) =>
  operations.map(mapBaasOperationToStablesHistoryItem);
